/* eslint-disable @typescript-eslint/naming-convention */
export class EquipmentRateDto {
  EquipmentID: string;
  UnitName: string;
  BillingRate: string;
}
